const AUTH_KEYS = [
  'token',
  'microsoftToken',
  'microsoftUserInfo',
  'googleToken',
  'googleUserInfo',
];

const SAVED_CREDENTIALS_KEY = 'savedCredentials';

export function persistSessionToken(token, rememberMe) {
  localStorage.removeItem('token');
  sessionStorage.removeItem('token');
  if (!token) return;
  if (rememberMe) {
    localStorage.setItem('token', token);
  } else {
    sessionStorage.setItem('token', token);
  }
}

export function clearAuthSession() {
  AUTH_KEYS.forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
}

export function loadRememberedIdentifier() {
  const raw = localStorage.getItem(SAVED_CREDENTIALS_KEY);
  if (!raw) return { identifier: '', rememberMe: false };
  try {
    const parsed = JSON.parse(raw);
    const identifier = parsed.identifier || '';
    const rememberMe = !!parsed.rememberMe;
    if (parsed.password) {
      localStorage.setItem(SAVED_CREDENTIALS_KEY, JSON.stringify({ identifier, rememberMe: true }));
    }
    return { identifier, rememberMe };
  } catch (_err) {
    localStorage.removeItem(SAVED_CREDENTIALS_KEY);
    return { identifier: '', rememberMe: false };
  }
}

export function saveRememberedIdentifier(identifier) {
  localStorage.setItem(
    SAVED_CREDENTIALS_KEY,
    JSON.stringify({ identifier: identifier || '', rememberMe: true }),
  );
}

export function clearRememberedIdentifier() {
  localStorage.removeItem(SAVED_CREDENTIALS_KEY);
}
